import React from "react";
import {
  Box,
  Heading,
  Text,
  Grid,
  GridItem,
  VStack,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  Divider,
  Badge,
  useColorModeValue,
} from "@chakra-ui/react";
import { ExamAttemptScore, QuestionSetAttemptScore } from "../Common/types";// Adjust path as needed
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";

interface ScoreViewerProps {
  scoreData: ExamAttemptScore;
}



const ScoreViewer: React.FC<ScoreViewerProps> = ({ scoreData }) => {
  const questionPaneBg = useColorModeValue("gray.50", "gray.700");
  const questionPaneBg1 = useColorModeValue("white", "gray.600");
  return (
    <Box maxW="1200px" mx="auto" p={6}>
      {/* Exam Summary Card */}
      <Box
        borderWidth="1px"
        borderRadius="2xl"
        p={6}
        mb={6}
        boxShadow="md"
        bg={questionPaneBg}
      >
        <Heading size="lg" mb={2}>
          {scoreData.title}
        </Heading>

        <Text mb={1}>Start: {fmtLocal(scoreData.student_start_time)}</Text>
       <Text mb={1}>
            End:&nbsp;
            {scoreData.student_end_time
              ? fmtLocal(scoreData.student_end_time)   // ✅ normal case
              : 'N/A'}                                
          </Text>

        <Grid templateColumns={["1fr", "repeat(3, 1fr)"]} gap={4} mt={4}>
          <Stat>
            <StatLabel>Score</StatLabel>
            <StatNumber>{scoreData.total_score_obtained.toFixed(2)} / {scoreData.max_exam_score}</StatNumber>
            <StatHelpText>Obtained vs Max</StatHelpText>
          </Stat>

          <Stat>
            <StatLabel>Percentage</StatLabel>
            <StatNumber>{scoreData.overall_percentage.toFixed(2)}%</StatNumber>
            <StatHelpText>Pass Mark: {scoreData.pass_percentage}%</StatHelpText>
          </Stat>

          <Stat>
            <StatLabel>Result</StatLabel>
            <StatNumber>{scoreData.overall_result}</StatNumber>
            <StatHelpText>
              <Badge colorScheme={scoreData.has_passed ? "green" : "red"}>
                {scoreData.has_passed ? "Passed" : "Failed"}
              </Badge>
            </StatHelpText>
          </Stat>
        </Grid>

        {scoreData.remarks && (
          <Text mt={4} fontStyle="italic" colorScheme="gray">
            Remarks: {scoreData.remarks}
          </Text>
        )}
      </Box>

      {/* Question Set Score Grid */}
      <VStack align="stretch" spacing={4}>
        {scoreData.attempted_question_set_score.map((qs: QuestionSetAttemptScore) => (
          <Box
            key={qs.exam_attempted_question_set_id}
            borderWidth="1px"
            borderRadius="xl"
            p={4}
            boxShadow="sm"
            bg={questionPaneBg1}
          >
            <Heading size="md" mb={2}>
              {qs.sequence}. {qs.title}
            </Heading>
            <Text>Start: {fmtLocal(qs.student_start_time)}</Text>
            <Text mb={1}>
              End:&nbsp;
              {qs.student_end_time
                ? fmtLocal(qs.student_end_time)   // ✅ normal case
                : 'N/A'}                               
            </Text>
            <Text>
              Score: {qs.total_score_obtained.toFixed(2)} / {qs.max_qset_score} (
              {qs.percentage_obtained.toFixed(2)}%)
            </Text>
            <Text>Pass Percentage: {qs.pass_percentage}%</Text>
            <Text>
              Result:{" "}
              <Badge colorScheme={qs.has_passed ? "green" : "red"}>
                {qs.has_passed ? "Passed" : "Failed"}
              </Badge>
            </Text>
            {qs.remarks && (
              <Text mt={2} fontStyle="italic" color="gray.600">
                Remarks: {qs.remarks}
              </Text>
            )}
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default ScoreViewer;
